import { createSingleEntityStore } from '@core/ngrx-legacy';

export interface DeprecatedIntelligenceSettings {
  aiWriterEnabled: boolean;
  evaluationInsightsEnabled: boolean;
}

export const {
  actions: DeprecatedIntelligenceSettingsActions,
  namespace: DeprecatedIntelligenceSettingsNamespace,
  reducer: DeprecatedIntelligenceSettingsReducer,
  selectors: DeprecatedIntelligenceSettingsSelectors,
} = createSingleEntityStore<DeprecatedIntelligenceSettings>()('IntelligenceSettings');
